import Config from "../config/Config";

const Api = {
  // Get using fetch

  get: async (url, token = null) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (token != null || token != undefined)
      myHeaders.append("Authorization", "Bearer " + token);

    //console.log("Get token", token);
    let options = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(Config.api_url + url, options)
      .then((response) => {
        if (response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("org_id");
          localStorage.removeItem("org_user");
          // window.location.href = "/adminqu/login";
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        //console.log("error", error);
      });
  },
  // post using fetch
  post: async (url, data, token = null) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (token != null || token != undefined)
      myHeaders.append("Authorization", "Bearer " + token);

    //console.log("Post token", token);

    let options = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(data),
    };
    return fetch(Config.api_url + url, options)
      .then((response) => {
        if (response.status == 401 && url != "/auth/login") {
          localStorage.removeItem("token");
          localStorage.removeItem("org_id");
          localStorage.removeItem("org_user");
          // window.location.href = "/adminqu/login";
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  },
  // patch using fetch
  patch: async (url, data, token = null) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (token != null || token != undefined)
      myHeaders.append("Authorization", "Bearer " + token);

    let options = {
      method: "PATCH",
      headers: myHeaders,
      body: JSON.stringify(data),
    };
    return fetch(Config.api_url + url, options)
      .then((response) => {
        if (response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("org_id");
          localStorage.removeItem("org_user");
          // window.location.href = "/adminqu/login";
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  },

  // delete using fetch
  delete: async (url, data = null, token = null) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (token != null || token != undefined)
      myHeaders.append("Authorization", "Bearer " + token);

    let options = {
      method: "DELETE",
      headers: myHeaders,
    };

    if (data != null) {
      options.body = JSON.stringify(data);
    }
    return fetch(Config.api_url + url, options)
      .then((response) => {
        if (response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("org_id");
          localStorage.removeItem("org_user");
          // window.location.href = "/adminqu/login";
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  },

  sendPushNotification: async (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "key=" + Config.fcmKey);

    let options = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(data),
    };
    return fetch("https://fcm.googleapis.com/fcm/send", options)
      .then((response) => response.json())
      .catch((error) => {
        //console.log(error);
      });
  },
};

export default Api;
